export default __webpack_public_path__ + "static/media/nov-logo.dcdccf8b.png";